import React from 'react';

const GoogleCalendarEmbed = ({ src }) => {
  if (!src) {
    return <p>Booking for this package will be available soon.</p>;
  }

  return (
    <iframe
      src={src}
      style={{ border: 0 }}
      width="100%"
      height="600"
      frameBorder="0"
      title="Google Calendar Appointment Scheduling"
    ></iframe>
  );
};

export default GoogleCalendarEmbed;
